import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";

const FileNameDialog = ({ open, onClose, onSave }) => {
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    // simple validation -> must end with .pdf
    if (!fileName.trim()) {
      setError("File name is required");
      return;
    }

    if (!fileName.toLowerCase().endsWith(".pdf")) {
      setError("Please include extension like demo.pdf");
      return;
    }

    setError("");
    onSave(fileName);
    setFileName("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Enter File Name</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="File Name"
          placeholder="demo.pdf"
          value={fileName}
          onChange={(e) => {
            setFileName(e.target.value);
            setError("");
          }}
          error={!!error}
          helperText={error || "Example: demo.pdf (include extension)"}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileNameDialog;
